import * as React from 'react';

import FileThreeD16 from './FileThreeD16';

export const fileThreeD16 = () => <FileThreeD16 />;

export default {
    title: 'Icon|Fill|FileThreeD16',
    component: FileThreeD16,
    parameters: {
        notes: "`import FileThreeD16 from 'box-ui-elements/es/icon/fill/FileThreeD16';`",
    },
};
